import Vue from 'vue'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'
import '@/styles/index.less'
import mixin from '@/mixin/'
import router from '@core/router'
import store from '@core/store/'
import api from '@core/api/'
import utils from '@/utils'
import Print from '@/utils/print'
import aggregated from '@/utils/aggregated'
import contentTitle from '@/components/common/contentTitle'
import SideBar from '@/components/common/SideBar'
import FlowTaskTracking from '@/components/common/FlowTaskTracking'
import SearchForm from '@/components/common/SearchForm'
import Image from '@/components/preview/Image'
import App from './App'
// eslint-disable-next-line no-unused-vars
import filters from '@/filters/'
const config = require('../../config/projectConfig')

Vue.component('contentTitle', contentTitle)
Vue.component('side-bar', SideBar)
Vue.component('flowtask-tracking', FlowTaskTracking)
Vue.component('search-form', SearchForm)
Vue.component('image-preview', Image)
Vue.mixin(mixin)

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Print)
Vue.prototype.$axios = axios
Vue.prototype.api = api
Vue.prototype.utils = utils
Vue.prototype.aggregated = aggregated
Vue.prototype.config = config
/* eslint-disable no-new */
window.myVue = new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/area-base/main.js